import { createFtueHighlightKey } from '@app/src/app/ftue/Highlight';

export namespace NavigationFtueKeys {
  export const addContent = createFtueHighlightKey();
  export const addPeople = createFtueHighlightKey();
}
